import { RootState } from "../../app/Store";
import { AudioName } from "./Audio";

export const selectAudioLibrary = (state: RootState) => state.audioLibrary;
export const selectAudio = (audioName: AudioName, state: RootState) =>
  state.audioLibrary[audioName];
export const selectAudioStatus = (audioName: AudioName, state: RootState) =>
  state.audioLibrary[audioName].status;
